import React from 'react';
import PropTypes from 'prop-types';

MiniCards.propTypes = {
  minicards: PropTypes.array,
};

export default function MiniCards({ minicards }) {
  return (
    <div className="mini-card-container">
      {minicards.map((minicard) => (
        <div key={minicard.name} className="mini-card">
          {minicard.icon}
          <span>{minicard.name}</span>
        </div>
      ))}
    </div>
  );
}
